import React, { useEffect } from 'react';
import PlatformInfoFactory from './PlatformInfoFactory';

const PlatformInfo = ({ platform, isLoading }) => {

  useEffect(() => {
    console.log(platform);
  }, []);

  return (
    <>
      {
        !isLoading &&
        platform ? (
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="my-12">
              <h1 className="text-3xl font-bold text-white0 mb-6">{platform.name}</h1>
              <p className="text-white1 text-lg">{platform.description}</p>
            </div>
            
            < PlatformInfoFactory platformName={platform.name} />
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
              <div>
                <h2 className="text-2xl font-bold text-white0 mb-6">Capabilities</h2>
                <ul>
                  {
                    platform.capabilities.map((capability, index) => (
                      <li key={index} className="mb-4">
                        <span className="inline-block bg-green text-white0 text-sm px-2.5 py-0.5 rounded-full">{capability.name}</span>
                        <p className="text-white1 mt-2">{capability.description}</p>
                      </li>
                    ))
                  }
                </ul>
              </div>
              <div>
                <h2 className="text-2xl font-bold text-white0 mb-6">Channel Kinds</h2>
                <ul>
                  {
                    platform.channelKindCapabilities.map((channelKind, index) => (
                      <li key={index} className="mb-4">
                        <span className="text-white0 mt-2">{channelKind.name}</span>
                        <p className="text-white1 mt-2">{channelKind.description}</p>
                      </li>
                    ))
                  }
                </ul>
              </div>
            </div>
          </div>
        )
        : (
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h1 className="text-3xl font-bold text-white0 my-6">Loading...</h1>
          </div>
        )
      }
    </>
  );
}

export default PlatformInfo;
